import { apiSlice } from '../../app/api/apiSlice'
import { encodeBase64 } from '../../helpers/images';

export const templatesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadTemplateSVG: builder.mutation ({
      query: ({sku_id, side, data}) => ({
        url: `v2/templatesvg/${sku_id}/${side}`,
        method: 'POST',
        body: {"svg": data}
      }),
      invalidatesTags: ["SKU"]
    }),
    downloadTemplate: builder.query ({
      query: ({name}) => ({
        url: `v1/rawfile/templates/${name}`,
        method: 'GET',
        responseHandler: (response) => response.text()
      }),
      keepUnusedDataFor: 0,
    }),
    getPreview: builder.query({
      query: ({ side, size, body }) => ({
        url: `v2/xoqweb_preview/${side}/${size}`,
        method: 'POST',
        body,
        // read data as blob
        responseHandler: (response) => response.blob(),
      }),
      // handle response by reading layout id from headers and saving PNG image
      // as base64 encoded
      transformResponse: async (response, meta) => {
        const img = await encodeBase64(response);
        return { img };
      },
      // cache preview images less time because they consume memory
      keepUnusedDataFor: 0,
    }),
    templatesByProductFamily: builder.query({
      query: (arg) => ({
        url: `v2/template/`,
        method: 'GET',
        params: {...arg}
      })
    })
  }),
})


export const {
  useUploadTemplateSVGMutation,
  useTemplatesByProductFamilyQuery,
  useGetPreviewQuery,
  useDownloadTemplateQuery
} = templatesApi
